// src/services/auth0/auth0Service.ts

import {
    checkSession,
    updateUserMetadata,
    createUserAndLogIn,
    loginUser,
    logoutUser,
    changePasswordRequest,
} from 'src/auth/auth0';
import { UserDetailsPartial } from 'src/auth/types';

// Service method for user logout
export const logoutUserService = async () => logoutUser();

// Service method to check session
export const checkSessionService = async () => checkSession();

// Service method for user login
export const loginUserService = async (email: string, password: string) =>
    loginUser(email, password);

// Service method to create a user and log them in
export const createUserAndLogInService = async (
    email: string,
    password: string,
    t?: (key: string) => string
) => createUserAndLogIn(email, password, t);

// Service method to update user metadata
export const updateUserMetadataService = async (userId: string, metadata: UserDetailsPartial) =>
    updateUserMetadata(userId, metadata);

// Service method to request password change
export const requestPasswordChangeService = async (email: string) => changePasswordRequest(email);
